Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplexObjectType = exports.ObjectTypeError = void 0;
const registry_1 = require("../objectType/registry");
const objectType_1 = require("../objectType/compiler/objectType");
const registry_2 = require("../inputObjectType/registry");
const objectTypeCompiler_1 = require("../inputObjectType/objectTypeCompiler");
var error_1 = require("./error");
Object.defineProperty(exports, "ObjectTypeError", { enumerable: true, get: function () { return error_1.ObjectTypeError; } });
function DuplexObjectType(options) {
    return (target) => {
        const inputConfig = { name: target.name + 'Input', ...options };
        const outputConfig = { name: target.name, ...options };
        const inputTypeCompiler = () => objectTypeCompiler_1.compileInputObjectTypeWithConfig(target, inputConfig);
        registry_2.inputObjectTypeRegistry.set(target, inputTypeCompiler);
        const outputTypeCompiler = () => objectType_1.compileObjectTypeWithConfig(target, outputConfig);
        registry_1.objectTypeRegistry.set(target, outputTypeCompiler);
    };
}
exports.DuplexObjectType = DuplexObjectType;
//# sourceMappingURL=DuplexObjectType.js.map